const options = {capture: true, once: true, passive: true};

document.addEventListener('touchstart', setupTouchableClass, options);

function setupTouchableClass(){
  document.body.classList.add('touchable');
  document.removeEventListener('touchstart', setupTouchableClass, options);
}